import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { useNotification } from '../../../../../../../hooks'
import { postMockApplicantCreditCheckDocument } from '../../../../../../RentalPortalApplicant'
import { useApplicantProfileContext } from '../../../../RentalPortalApplicantProfile.hooks'

export function useApplicantCreditCheckDocument() {
  const { t } = useTranslation()

  const { handleAddErrorNotification } = useNotification()

  const { applicantId, handleEntityReload } = useApplicantProfileContext()

  const [isSubmitting, setSubmitting] = useState(false)

  async function attachDocument(documentId) {
    try {
      await postMockApplicantCreditCheckDocument({ applicantId, documentId })

      await handleEntityReload()
    } catch {
      handleAddErrorNotification({
        textButtonValue: t('RentalPortal.ListingRetryBtnKey'),
        title: t('RentalPortal.ApplicantCreditCheckAttachErrorKey'),
        onClickTextButton: () => attachDocument(documentId),
      })
    } finally {
      setSubmitting(false)
    }
  }

  function handleStartUpload() {
    setSubmitting(true)
  }

  function handleFinishUpload(acceptedFiles) {
    const documentId = acceptedFiles?.[0]?.id

    return documentId ? attachDocument(documentId) : setSubmitting(false)
  }

  function handleUploadErrors() {
    setSubmitting(false)

    handleAddErrorNotification({
      title: t('RentalPortal.ApplicantCreditCheckAttachErrorKey'),
    })
  }

  return {
    handleFinishUpload,
    handleStartUpload,
    handleUploadErrors,
    isSubmitting,
  }
}
